import React, { useState, useContext, useEffect, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import moduleConfig from "./moduleConfig";
import { Store as toast } from "react-notifications-component";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import { isEmpty } from "../../../helpers/CommonHelper";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSRichTextEditor from "../../UI/forms/CMSRichTextEditor";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import CMSFormTextArea from "../../UI/forms/CMSFormTextArea";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import {
  updateInitialState,
  updateReducer,
} from "../../../reducers/module/updateReducer";
import {
  loadItemGeneral,
  onSubmitGeneral,
} from "../../../helpers/ModuleHelperFunctions";
import CMSFormTime from "../../UI/forms/CMSFormTime";
import CMSFormDate from "../../UI/forms/CMSFormDate";

const DiscountCouponUpdate = () => {
  const [updateState, updateDispatch] = useReducer(
    updateReducer,
    updateInitialState
  );
  const [formInitialValues, setFormInitialValues] = useState({});
  const { setBreadcrumb } = useContext(BreadcrumbContext);

  let { id } = useParams();
  let navigate = useNavigate();

  const loadItem = async () => {
    await loadItemGeneral(id, `${moduleConfig.url}/${id}`, updateDispatch);
  };

  useEffect(() => {
    //console.log("useEffect called for [id]")
    loadItem();

    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      // moduleConfig.breadcrumbs.details,
      moduleConfig.breadcrumbs.update,
    ]);
  }, [id]);
  useEffect(() => {
    if (updateState.data.item && updateState.data.item._id) {
      //if (moduleConfig.fields && moduleConfig.fields.length > 0) {

      // let formFieldsWithFetchData = {}
      // moduleConfig.fields.map((field, index) => {

      //     formFieldsWithFetchData[field.fieldName] = updateState.data.item[field.fieldName]
      // })
      // console.log("Here =>>>>>>>>>>>>>>", formFieldsWithFetchData)
      setFormInitialValues(updateState.data.item);

      //};
    }
  }, [updateState.data]);

  return (
    <DashboardLayout>
      {updateState.status === "fetching" && updateState.isLoading && (
        <ContainerLoading />
      )}
      {updateState.error && updateState.status === "fetchFailed" ? (
        <BlockErrorMessage error={updateState.error} />
      ) : (
        <>
          <ModuleHeader
            moduleTitle={`Update ${moduleConfig.singleItemTitle}`}
            moduleUrl={moduleConfig.url}
          ></ModuleHeader>

          {Object.keys(formInitialValues).length > 0 &&
            updateState.data &&
            updateState.data.item &&
            !isEmpty(updateState.data.item._id) && (
              <section className="content">
                <Card>
                  <Card.Body>
                    {updateState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    {/* {console.log(formInitialValues)} */}
                    <Formik
                      initialValues={{
                        ...formInitialValues,
                        //file:updateState.data.item.image,
                      }}
                      validationSchema={yup.object({
                        title: yup
                          .string()
                          .required("Title is required")
                          .max(50, "Title cannot exceed 50 characters"),

                        couponCode: yup
                          .string()
                          .required("Coupon code is required")
                          .max(10, "Coupon code cannot exceed 10 characters"),

                        discountFor: yup
                          .string()
                          .required("Discount for is required"),

                        discountType: yup
                          .string()
                          .required("Discount type is required"),

                        discountValue: yup
                          .number()
                          .typeError("Discount value must be a number")
                          .required("Discount value is required"),

                        maxUsageLimit: yup
                          .number()
                          .typeError("Maximum usage limit must be a number")
                          .required("Maximum usage limit is required"),

                        minAmount: yup
                          .number()
                          .typeError("Minimum amount must be a number")
                          .required("Minimum amount is required"),

                        startDate: yup
                          .string()
                          .required("Start date is required"),

                        endDate: yup.string().required("End date is required"),

                        description: yup.string(),

                        showOnHome: yup.string().required("Want to show on website"),
                        status: yup.string().required("Status is required"),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        await onSubmitGeneral(
                          values,
                          `${moduleConfig.url}/${id}`,
                          moduleConfig.url,
                          updateDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {updateState.error && (
                            <FormErrorMessage error={updateState.error} />
                          )}

                          <CMSFormInput
                            name="title"
                            label="Title"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="couponCode"
                            label="Coupon Code"
                            required={true}
                            form={form}
                          />

                          <CMSFormSelect
                            name="discountFor"
                            label="Discount For"
                            form={form}
                             required={true}
                            options={[
                              { label: "Product", value: "Product" },
                              { label: "Subscription", value: "Subscription" },
                            ]}
                          />

                          <CMSFormSelect
                            name="discountType"
                            label="Discount Type"
                             required={true}
                            form={form}
                            options={[
                              { label: "Percentage", value: "Percentage" },
                              { label: "Fixed Value", value: "Fixed Value" },
                            ]}
                          />

                          <CMSFormInput
                            name="discountValue"
                            label="Discount Value"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="minAmount"
                            label="Minimum Order Amount"
                            info="Zero value for any amount"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="maxUsageLimit"
                            label="Max. Usage Limit"
                            info="Zero value for unlimited"
                            required={true}
                            form={form}
                          />

                          <CMSFormDate
                            name="startDate"
                            label="Start Date"
                            required={true}
                            form={form}
                            minDate={new Date()}
                            value={new Date(form.values["startDate"])}
                            // minDate={new Date(getPackageStartDate(activeClient))}
                            // maxDate={new Date(getPackageEndDate(activeClient))}
                            disabled={false}
                          />

                          {/* <CMSFormTime
                            name="startTime"
                            label="Start Time"
                            required={true}
                            form={form}
                          />   */}

                          <CMSFormDate
                            name="endDate"
                            label="End Date"
                            required={true}
                            form={form}
                            minDate={new Date()}
                            value={new Date(form.values["endDate"])}
                            // minDate={new Date(getPackageStartDate(activeClient))}
                            // maxDate={new Date(getPackageEndDate(activeClient))}
                            disabled={false}
                          />

                          {/* <CMSFormTime
                            name="endTime"
                            label="End Time"
                            required={true}
                            form={form}
                          />  */}

                          {/* <CMSFormTextArea
                            name="description"
                            label="Description"
                            form={form}
                            maxLength={300}
                          /> */}

                          <CMSFormSelect
                            name="showOnHome"
                            label="Want to show on website?"
                            form={form}
                             required={true}
                            options={[
                              
                              { label: "Yes", value: "1" },
                              { label: "No", value: "0" },
                            ]}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                             required={true}
                            form={form}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />
                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            )}
        </>
      )}
    </DashboardLayout>
  );
};
export default DiscountCouponUpdate;
